var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 25",
    style: {
      enableBackground: "new 0 0 28 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,5C26,5,28,7,28,9.5c0,2.5-2,4.5-4.5,4.5H1.2C0.5,14,0,13.5,0,12.8s0.5-1.2,1.2-1.2h22.3 c1.1,0,2-0.9,2.1-2c0-1.1-0.9-2.1-2-2.1c-0.8,0-1.5,0.5-1.9,1.2c-0.2,0.5-0.7,0.8-1.2,0.7c-0.9,0-1.4-0.9-1.1-1.7 c0.2-0.5,0.6-1,1-1.4C21.2,5.5,22.3,5,23.5,5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4,0C15,0,17,2,17,4.5C17,7,14.9,9,12.4,9H3.2C2.6,9,2,8.5,2,7.8s0.6-1.2,1.2-1.2h9.2c1.1,0,2.1-0.9,2.1-2 c0-1.1-0.9-2.1-2.1-2.1c-0.8,0-1.6,0.5-1.9,1.2c-0.2,0.5-0.7,0.8-1.2,0.7c-0.9,0-1.5-0.9-1.1-1.7c0.2-0.5,0.6-1,1-1.4 C10.1,0.5,11.3,0,12.4,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,16c0,0,0.7,0-10.8,0.2c-0.2,0-0.4,0-0.6,0c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.2,1.2,1.2 c0.2,0,0.4,0,0.6,0c3.4-0.1,10.5-0.2,10.8-0.2c1.2,0,2.1,1,2,2.2c-0.1,1.1-1,1.9-2,1.9c-0.8,0-1.5-0.5-1.8-1.2 c-0.2-0.5-0.7-0.8-1.1-0.7c-0.9,0-1.4,0.9-1.1,1.7c0.2,0.5,0.6,1,1,1.4c0.8,0.8,1.9,1.3,3.1,1.3c2.5,0,4.5-2.1,4.4-4.6 C21.9,18,20,16,17.5,16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.e349d2545424ff7d81c70fdb9c8e8b73.svg";
export { ForwardRef as ReactComponent };